"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _IframeUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/IframeUtility"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used for calculating the application size when inside an iframe.
 *
 * Deprecated, use @ikea-aoa/ikea-shared-utils/lib/util/IframeUtility
 */
var IframeUtilityWrapper = /*#__PURE__*/function () {
  function IframeUtilityWrapper() {
    _classCallCheck(this, IframeUtilityWrapper);
  }

  _createClass(IframeUtilityWrapper, null, [{
    key: "calculateHeight",

    /**
     * Calculates the application height based on width and platform.
     *
     * @deprecated
     * @param {object} width Application width.
     * @param {string} [platform] Application plattform (nwp or irw). Default is "irw".
     * @returns {number} Calculated height.
     */
    value: function calculateHeight(width) {
      var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'irw';

      _Console.default.warn('IframeUtility has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/IframeUtility" instead.');

      return _IframeUtility.default.calculateHeight(width, platform);
    }
    /**
     * Returns the device type based on the application size.
     *
     * @deprecated
     * @returns {string} Device type (mobile, desktop or tablet).
     */

  }, {
    key: "getDeviceType",
    value: function getDeviceType() {
      _Console.default.warn('IframeUtility has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/IframeUtility" instead.');

      return _IframeUtility.default.getDeviceType();
    }
    /**
     * Returns the current orientation based on width.
     *
     * @deprecated
     * @param {number} width Application width.
     * @returns {string} Orientation (landscape or portrait).
     */

  }, {
    key: "getOrientation",
    value: function getOrientation(width) {
      _Console.default.warn('IframeUtility has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/IframeUtility" instead.');

      return _IframeUtility.default.getOrientation(width);
    }
    /**
     * Returns the header height.
     *
     * @deprecated
     * @param {string} platform Platform (nwp, irw, m2, mobile etc.).
     * @returns {number} Available height.
     */

  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight(platform) {
      _Console.default.warn('IframeUtility has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/IframeUtility" instead.');

      return _IframeUtility.default.getHeaderHeight(platform);
    }
  }]);

  return IframeUtilityWrapper;
}();

exports.default = IframeUtilityWrapper;